export const environment = {

  production: true,
  environmentType: 'production',

  web: {
    baseUrl: '//studio.mtm.video',
    avatarUrl: 'https://gateway.studio.mtm.video/api/public-images/USER/AVATAR/%USERNAME%',
  },

  api: {
    baseUrl: 'https://gateway.studio.mtm.video',
    mockapiUrl: '//58c14598e8215412002f7cf5.mockapi.io',
    analyticsUrl: 'https://analytics.studio.mtm.video'
  },

  adminConsole: {
    baseUrl: 'https://admin.ui.studio.mtm.video',
    authPath: '/auth/sso-callback'
  },

  adminStudio: {
    baseUrl: 'https://admin.studio.mtm.video',
  },

  websocket: {
		chatBaseUrl: 'https://gateway.studio.mtm.video/chat'
	},

	versionCheckURL: 'https://studio.mtm.video/version.json',
	healthCheckURL: 'https://gateway.studio.mtm.video/mtm-manage/health',
	captchaSiteKey: '6LcPFJ0rAAAAAKZbcvTFZ_ReQEGPD0WudO8pgua-',
	sentry: {
		dsn: 'https://95f1a1cc9fcef447fbed014d57de5595@o4509076661534720.ingest.de.sentry.io/4509077615411281',
		enabled: true,
	},
	userflow: {
		token: 'userflow-token',
		enabled: false,
	},
  iam: {
    iamApiUrl: 'https://iam.studio.mtm.video',
    appApiUrl: 'https://gateway.studio.mtm.video',
    ssoCallbackUrl: '/sso/callback',
    ssoCallbackHost: 'https://studio.mtm.video',
    authProcessUrl: '/entry/auth/process',
    resetPasswordCallbackUrl: '/entry/auth/reset',
    serviceUuid: '00e9b227-eb3a-4d96-bc68-5f0027cb785a',
    ssoUrl: {
      google: 'https://gateway.studio.mtm.video/oauth2/authorization/google',
      azure: 'https://gateway.studio.mtm.video/oauth2/authorization/azure',
    },
  },

  drive: {
    apiUrl: 'https://drive.svc.studio.mtm.video',
  },

  admin: {
    apiUrl: 'https://admin.gtw.studio.mtm.video/gtw',
  },

  context: {
    apiUrl: 'https://context.studio.mtm.video',
  },
};
